/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIArticleAutocompleteSuggestion
 */
export interface APIArticleAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIArticleAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleAutocompleteSuggestion
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleAutocompleteSuggestion
     */
    number: string;
}

/**
 * Check if a given object implements the APIArticleAutocompleteSuggestion interface.
 */
export function instanceOfAPIArticleAutocompleteSuggestion(value: object): value is APIArticleAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function APIArticleAutocompleteSuggestionFromJSON(json: any): APIArticleAutocompleteSuggestion {
    return APIArticleAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIArticleAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'number': json['number'],
    };
}

export function APIArticleAutocompleteSuggestionToJSON(value?: APIArticleAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'number': value['number'],
    };
}

